import { AlertTriangle } from 'lucide-react';
import { useErrorText, useT } from '../../i18n';
import { Button } from './button';

/** Renders a failed query without ever exposing technical detail (§28). */
export const ErrorState = ({ error, onRetry }: { error: unknown; onRetry?: () => void }) => {
  const { t } = useT();
  const { errorText } = useErrorText();

  return (
    <div className="flex flex-col items-center gap-2 px-6 py-12 text-center" role="alert">
      <AlertTriangle className="size-5 text-fail" />
      <p className="text-[14px] font-medium text-ink">{t('error.loadFailed')}</p>
      <p className="max-w-md text-[13px] text-ink-muted">{errorText(error)}</p>
      {onRetry ? (
        <Button className="mt-3" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      ) : null}
    </div>
  );
};
